import { useSelector } from 'react-redux';
import { RootState } from '../../reducer';
import { FunctionComponent, useState } from "react";
import { Button } from '../../tailwindcomponents';
import { Input, Snackbar, Table, TableCell, TableRow } from './../../tailwindcomponents';
import AccessControlApi from "../../api/accessControl";
import UserApi from '../../api/userApi';
import { User } from "../../types/user";
import ProfileImg from '../../components/Images/ProfileImg';

type AlertColor = 'success' | 'info' | 'warning' | 'error';

type UserHistoryProps = {
    setLoading: Function,
    refresh: Function
}

const AllUsers: FunctionComponent<UserHistoryProps> = ({ setLoading, refresh }) => {
    const store = useSelector((state: RootState) => state);
    const allUsers = store.employees.all_employees.filter(s => s.visible === true);
    const [user, setUser] = useState<string>("");
    const [snackbarMessage, setSnackbarMessage] = useState<string>("");
    const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor>("success");

    const generateTableBody = (row: User, index: number) => {
        return (
            <TableRow>
                <TableCell >
                    <div className="flex flex-wrap">
                        <ProfileImg imgKey={index} userName={row.userName?.split('@')[0]} />
                    </div>
                </TableCell>
                <TableCell> {row.name}</TableCell>
                <TableCell>{row.userName}</TableCell>
                <TableCell>{row.job_title}</TableCell>
            </TableRow>
        )
    }

    const onCreateUser = () => {
        setLoading(true);
        UserApi.CreateUser(user).then(res => {
            setUser('');
            refresh();
            setLoading(false);

            if (res.status === true) {
                setSnackbarMessage(res.message);
                setSnackbarSeverity('success');
            }
            else {
                setSnackbarMessage(res.message);
                setSnackbarSeverity('error');
            }
        })
    }

    const onRefreshUsers = () => {
        setLoading(true);
        AccessControlApi.SyncMicrosoftGraphAndMaintener().then(res => {
            setLoading(false);
        });
    }

    async function uploadUsersPhotosToAwsBucket() {
         for(let i = 0; i < allUsers.length; i++){
            AccessControlApi.UploadUserPhotoToAwsBucket(allUsers[i]?.userName?.split('@')[0]).then();
        }
    }
    return (
        <div>
            <div className="ds-filter-bar">
                <Input
                    multiline={false}
                    label_text="User name"
                    help_text="Please type in a username e.g. username@icelandair.is"
                    type="text"
                    value={user}
                    width={100}
                    onTextChange={(value: string) => setUser(value)}
                />
                <div className="ds-filter-actions">
                    <Button variant="contained" color='primary' onClick={() => onCreateUser()}>Create user</Button>
                    <Button variant="contained" color='primary' onClick={() => onRefreshUsers()}>Refresh users</Button>
                    <Button variant="contained" color='primary' onClick={() => uploadUsersPhotosToAwsBucket()}>Upload user photos</Button>
                </div>
            </div>
            <Table
                headers={["", "NAME", "USERNAME", "JOBTITLE"]}
                rows={allUsers}
                generateBody={(row: any, index: number) => generateTableBody(row, index)}
                pagination={true}
                defaultRowsPerPage={10}
                skipIndexCol={true}
            />
            <Snackbar
                onSnackBarClose={() => setSnackbarMessage("")}
                open={snackbarMessage.length > 0}
                message={snackbarMessage}
                autoHide={true}
                horizontalPosition='right'
                severity={snackbarSeverity}
            >
            </Snackbar>
        </div>
    )
}
export default AllUsers;